export default "__VITE_ASSET__7j8EwWtt__"